module.exports = __webpack_public_path__ + "static/media/lumin-bottles-on-stones.2681c48c.jpg";